<template>
  <v-snackbar
    v-model="notification.show"
    :color="notification.color"
    multi-line
    top
    :timeout="6000"
    dark
  >
    {{notification.message }}
    <v-btn
      color="white"
      outlined
      @click="hideNotification"
    >
      Cerrar
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import types from '@/types';

export default {
  computed: {
    ...mapState(
      `${types.APP}`, [
        'notification',
      ],
    ),
  },
  methods: {
    ...mapMutations({
      [types.HIDE_NOTIFICATION]: `${types.APP}/${types.HIDE_NOTIFICATION}`,
    }),
    hideNotification() {
      this[types.HIDE_NOTIFICATION]();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Notification.vue